import React from 'react'
import { Box, Link } from "@mui/material";
import { useRouter } from "next/router";
import { imagesWEBP } from '../../../constants/webpImages';
import Style from './Categories.module.scss';
import Image from 'next/image';
const categoriesList =[
    {
        text: "Electric Commercial Vehicle",
        image: imagesWEBP?.cargoLogo4w,
        redirect: "/electric-commercial-vehicles",
        selected:true
    },
    {
        text: "Electric Passenger Vehicle",
        image: imagesWEBP?.passengerLogo,
        redirect: "/electric-commercial-vehicles/passenger",
        selected:false
    },
    {
        text: "Electric Cargo Vehicle",
        image: imagesWEBP?.cargoLogo,
        redirect: "/electric-commercial-vehicles/cargo",
        selected:false
    },
]

const Categories = () => {
  const navigate = useRouter();
  
  return (
    <Box
    className={Style.mainSection}
    >
        <Box 
        className={Style.sectionHeading}
        >
        Check Out Our Vehicles
        </Box>
        <Box 
        className={Style.categories}
        >
                {categoriesList.map((category, index) => (
                       <Box key={index}
                       className={
                            Style.category
                       }
                     
                       >
                        <Link
                        href={category.redirect}
                        className={Style.categoryLink}
                        onClick={(e) => {
                            e.preventDefault();
                            navigate.push(category.redirect);
                        }}
                        >
                            <Box
                            className={`${Style.categoryImageContainer}  ${category.selected && Style.selectedCategory}`}
                            >
                                <Image
                                src={category.image}
                                alt={category.text}
                                fill
                                className="w-full h-full object-contain"
                                />
                            </Box>
                            <Box
                            className={Style.categoryTextContainer}
                            >
                                <div
                                className={Style.categoryText}
                                >
                                {category.text}
                                </div>
                               
                            </Box>
                        </Link>
                        </Box>
                ))}
        </Box>
    </Box>
  )
}
export default Categories
